import Casier from "./Casier";
import Dcp from "./Dcp";
import FiletMaillant from "./FiletMaillant";
import ResteSenne from "./ResteSenne";
import Palangre from "./Palangre";

const laneOne = 80
const laneTwo = 133
const laneThree = 186
const laneFour = 239
const laneFive = 292

export default class TestSpawner extends Phaser.GameObjects.Container {
    constructor(scene, x, y, spawnDelay) {
        super(scene, x, y, []);

        this.scene = scene;
        this.spawnDelay = spawnDelay
        this.obstacles = []
        this.isSpawnerActive = true
        this.obstacleSpeed = 0
        scene.add.existing(this);

        this.spawner = this.scene.time.addEvent({
            delay: this.spawnDelay,
            callback: () => {
                if (!this.isSpawnerActive) return

                let obstacle = undefined
                let random = Math.random()

                // // console.log("random", random)
                
                if (random > 0.8) {
                    // // console.log("casier")
                    if (this.obstacles.find(obstacle => obstacle.type === 'casier') === undefined ) {
                        obstacle = new Casier(this.scene, this.scene.width, laneFive , { showHitbox: false }) // Poubelle
                    }
                } else if (random > 0.6) {
                    // // console.log("dcp")
                    if (this.obstacles.find(obstacle => obstacle.type === 'dcp') === undefined) {
                        obstacle = new Dcp(this.scene, this.scene.width, laneTwo , { showHitbox: false }) // Poubelle
                    }
                    
                } else if (random > 0.4) {
                    // // console.log("filet")
                    if (this.obstacles.find(obstacle => obstacle.type === 'filetMaillant') === undefined) {
                        obstacle = new FiletMaillant(this.scene, this.scene.width, laneTwo , { showHitbox: false }) // Poubelle
                    }
                    
                } else if (random > 0.2) {
                    // // console.log("palangre")
                    if (this.obstacles.find(obstacle => obstacle.type === 'palangre') === undefined) {
                        obstacle = new Palangre(this.scene, this.scene.width, laneOne , { showHitbox: false }) // Poubelle
                    }
                    
                } else if (random) {
                    // // console.log("resteSenne")
                    if (this.obstacles.find(obstacle => obstacle.type === 'resteSenne') === undefined) {
                        obstacle = new ResteSenne(this.scene, this.scene.width, laneFive , { showHitbox: false }) // Poubelle
                    }
                }

                if (obstacle != undefined) {
                    this.obstacles.push(obstacle)
                }
            }
        })
    }

    setActive(isActive) {
        this.isSpawnerActive = isActive
    }

    moveObstacles(delta) {
        this.obstacles.forEach((obstacle, index) => {
                obstacle.x -= (obstacle.speed + this.obstacleSpeed) * (delta / 1200)  // On fait avancer l'obstacle vers le joueur
                if (obstacle.x <= -obstacle.width) {
                    obstacle.destroy()
                    this.obstacles.splice(index, 1) // On le supprime quand il sort de l'écran
                    this.scene.testSpawnOK = true
                }
                return obstacle.x
        })
    }
}